<template>
  <div class="login">
    <div class="cl-logo">
      <img src="../../assets/images/newLogo.png" class="cl-cloudImage">
      <el-button class="cl-changeLanguage" @click="goChinese" size="mini" round>中文</el-button>
      <el-button class="cl-register" @click="register" size="mini" round>Register</el-button>
    </div>
    <div class="cl-loginCard">
      <div class="cl-loginlogo">
        <img src="../../assets/images/loginlogoenglish.png">
      </div>
      <div class="cl-form">
        <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item prop="email" class="cl-tel">
            <el-input
              style="width: 230px;"
              placeholder="Email"
              v-model="ruleForm.email"
              maxlength="30">
              <i slot="prefix" class="el-input__icon el-icon-message"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password" class="cl-code">
            <el-input
              style="width: 230px;"
              placeholder="Password"
              show-password
              maxlength="16"
              v-model="ruleForm.password">
              <i slot="prefix" class="el-input__icon el-icon-key"></i>
            </el-input>
          </el-form-item>
          <el-button class="cl-enlogin" @click="login('ruleForm')">Login</el-button>
        </el-form>
      </div>
      <el-dialog :visible.sync="centerDialogVisible" center width="440px" @close="closeDialog" :close-on-click-modal="false">
        <div class="cl-imgbox">
          <img src="../../assets/images/loginlogoenglish.png" class="cl-registerlogo">
        </div>
        <el-form :model="registerForm" :rules="registerRules" ref="registerForm" class="demo-ruleForm">
          <el-form-item prop="email">
            <el-input
              placeholder="Email"
              v-model="registerForm.email"
              maxlength="50">
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              placeholder="Password"
              type="password"
              v-model="registerForm.password"
              maxlength="30">
            </el-input>
          </el-form-item>
          <el-form-item prop="rePassword">
            <el-input
              placeholder="Re-enter password"
              type="password"
              v-model="registerForm.rePassword"
              maxlength="30">
            </el-input>
          </el-form-item>
          <el-form-item prop="realName">
            <el-input
              placeholder="Your name"
              v-model="registerForm.realName"
              maxlength="30">
            </el-input>
          </el-form-item>
          <el-form-item prop="companyNameEn">
            <el-input
              placeholder="Company"
              v-model="registerForm.companyNameEn"
              axlength="60">
            </el-input>
          </el-form-item>
          <el-form-item prop="input4">
            <el-autocomplete
              v-model="registerForm.input4"
              value-key="enName"
              :fetch-suggestions="querySearchAsync"
              placeholder="Location - Select"
              @select="handleSelect"
              style="width: 100%;">
            </el-autocomplete>
          </el-form-item>
          <el-form-item prop="imgVerifyCode">
            <el-input style="width: 265px;"
              placeholder="Verification code"
              v-model="registerForm.imgVerifyCode">
            </el-input>
            <el-image :src="this.verifiCodeURL" @click="reloadImage" style="vertical-align: middle;"> </el-image>
          </el-form-item>
          <el-checkbox v-model="registerForm.checked">
            By creating an account, <br>
            you agree to Conditions of Use and Privacy Notice.<br>
          </el-checkbox>
        </el-form>
        <el-button class="cl-registerButton" @click="successRegister('registerForm')">Register</el-button>
      </el-dialog>
    </div>
    <div style="position:absolute;bottom:50px;width:100%;color:#B28814;font-size:18px;font-weight: bold;">
      <div class="namediv2" >
        <span class="copyright1"><a target="_blank" style="display:inline-block;text-decoration: underline;" href="http://beian.miit.gov.cn">辽ICP备：辽B-2-4-20080120-23</a> COPYRIGHT © 2019 WIFFA SHIPPINGTECH CO., LTD. All RIGHTS RESERVED  大连万发联合航贸科技有限公司</span>
      </div>
      </div>
  </div>
</template>

<script>
  export default {
    name: 'index',
    data() {
      return {
        verifiCodeURL:'',
        centerDialogVisible:false,
        ruleForm: {
          email: '',
          password: '',
        },
        rules: {
          email: [
            { required: true, message: 'Please enter email address', trigger: ['change'] },
          ],
          password: [
            { required: true, message: 'Please enter your password',  trigger: ['change'] },
            { min: 8, max: 16, message: "Please enter characters of length 8 to 16 bits", trigger: "blur" }
          ]
        },
        registerForm: {
          realName: '',
          companyNameEn: '',
          input4: '',
          email: '',
          password: '',
          rePassword: '',
          checked:false,
          imgVerifyCode:''
        },
        registerRules: {
          realName: [
            { required: true, message: 'Your name', trigger: ['blur'] },
          ],
          companyNameEn: [
            { required: true, message: 'Company', trigger: ['blur'] }
          ],
          input4: [
            { required: true, message: 'Location - Select', trigger: ['change'] },
          ],
          email: [
            { required: true, message: 'email', trigger: ['blur'] }
          ],
          password: [
            { required: true, message: 'password', trigger: ['blur'] },
            { min: 8, max: 16, message: "Please enter characters of length 8 to 16 bits", trigger: "blur" }
          ],
          rePassword: [
            { required: true, message: 'Re-enter password', trigger: ['blur'] },
            { min: 8, max: 16, message: "Please enter characters of length 8 to 16 bits", trigger: "blur" }
          ],
          imgVerifyCode:[
            { required: true, message: 'Verification code', trigger: ['blur'] }
          ],
        },
      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      //点击刷新图片
      reloadImage(){
        let timeCode = new Date().getTime()
        this.verifiCodeURL = this.$downloadBaseUrl + '/cloudmoney/image/getVerifiCode' + '?=' + timeCode
      },
      register() {
        this.centerDialogVisible = true
        let timeCode = new Date().getTime()
        this.verifiCodeURL = this.$downloadBaseUrl + '/cloudmoney/image/getVerifiCode' + '?=' + timeCode
      },
      closeDialog(){
        this.$refs['registerForm'].resetFields()
        this.registerForm.checked = false
      },
      goChinese() {
        this.$router.push({
          name: "login",
          query: {}
        })
      },
      //英文登录
      login(formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            this.$axios.post('/clientUserLoginEn/login', {
              "email": this.ruleForm.email,
              "password": this.ruleForm.password
            })
            .then(response => {
              if (response.code == 0) {
                localStorage.setItem('locale', 'en')
                this.$i18n.locale = localStorage.getItem('locale')
                this.$router.push({
                  name: "personaloverview",
                })
              }else if(response.code == -1){
                this.$message.error(response.msg)
              }
            })
            .catch(error => {
              console.log(error);
              this.abnormalSituation()
            });
          }
        })
      },
      //国家下拉选(检索)
      querySearchAsync(queryString, cb) {
        var results = [];
        if(queryString){
          this.$axios.get('/country/list',{
            params: {
              "type": "EN",
              "key": queryString
            }
          })
          .then(response=> {
            if(response.code==0){
              results = response.data;
            }
          })
          .catch(error=> {
            console.log(error);
            this.abnormalSituation()
          })
        }else{
          this.$axios.get('/country/list',{
            params: {
              "type": "EN"
            }
          })
          .then(response=> {
            if(response.code==0){
              results = response.data;
            }
          })
          .catch(error=> {
            console.log(error);
            this.abnormalSituation()
          })
        }
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 1000);
      },
      handleSelect(item) {
        console.log(item);
        this.countryId = item.countryId;
      },
      // 英文注册
      successRegister(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.registerForm.checked != true){
              this.$message.error('You need to agree to Conditions of Use and Privacy Notice')
              return
            }
            this.$axios.post('/registEn/register', {
              "realName": this.registerForm.realName,
              "companyNameEn": this.registerForm.companyNameEn,
              "countryId": this.countryId,
              "email": this.registerForm.email,
              "password": this.registerForm.password,
              "rePassword": this.registerForm.rePassword,
              "agreeFlag": "1",
              "imgVerifyCode":this.registerForm.imgVerifyCode
            })
            .then(response=> {
              if(response.code == 0){
                if(response.code == 0){
                    localStorage.setItem('locale', 'en')
                    this.$i18n.locale = localStorage.getItem('locale')
                    this.$router.push({
                      name: "personaloverview"
                    })
                    this.centerDialogVisible = false
                  }else{
                    this.$message({
                      type: 'error',
                      message: response.msg
                    });
                  }
              }else if(response.code == -1){
                this.$message.error(response.msg)
              }
            })
            .catch(error=> {
              console.log(error);
              this.abnormalSituation()
            })
          }
        })
      },
    },
    components: {

    }
  }
</script>

<style scoped>
  .login {
    background-color: rgb(240, 242, 245);
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url("../../assets/images/cloudplatform.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    background-attachment: fixed
  }
  .cl-changeLanguage{
    background-color: #fd7d00 !important;
    color: white !important;
    float: right;
    margin: 0;
    margin-right: 30px;
    width: 70px;
    border: #fd7d00 solid 1px !important;
  }
  .cl-logo{
    padding-top:2%;
    padding-left:2%;
    width: auto;
  }
  .cl-cloudImage{
    width: auto;
    height: 30px;
  }
  .cl-loginlogo{
    text-align: center;
    margin: 0;
    margin-top: 9%;
  }
  .cl-loginlogo img{
    width: auto;
    height: 55px;
  }
  .cl-form{
    margin-top: 4%;
    width: 100%;
    height: 40px;
    text-align: center;
  }
  .cl-tel{
    margin-top: 0px;
  }
  .cl-code{
    margin-top: 0px;
  }
  .cl-enlogin{
    width: 120px;
    height: 40px;
    background-color: #fd7d00 !important;
    border: #fd7d00 solid 1px !important;
    color: white !important;
  }
  .cl-register{
    background-color: #fd7d00 !important;
    color: white !important;
    float: right;
    margin: 0;
    margin-right: 20px;
    width: 76px;
    border: #fd7d00 solid 1px !important;
  }
  .cl-info{
    position: absolute;
    bottom: 10px;
    margin-left:2%;
    width: 98%;
  }
  .cl-telImage{
    width: auto;
    height: 35px;
  }
  .cl-text{
    float: right;
    margin-top: 20px;
    margin-right: 20px;
    bottom: 0px;
    font-size: 8px;
    font-family:"微软雅黑";
    color: dimgrey;
  }
  .cl-imgbox{
    text-align: center;
    margin: 0;
    margin-top: -40px;
  }
  .cl-registerlogo{
    width: auto;
    height: 35px;
  }
  .demo-ruleForm{
    margin-top: 20px;
  }
  .cl-registerButton{
    margin-top: 20px;
    width: 390px;
    background-color: #d5aa5e !important;
    border: #d5aa5e solid 1px !important;
    color: white !important;
  }
  .namediv2{
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .cl-cloudImage{
    width: auto;
    height: 140px;
    width: 500px;
    position: absolute;
  }
  /deep/ .el-input--suffix .el-input__inner{
    padding-right: 15px !important;
  }
</style>
